import {
  ADD_BACKGROUND,
  ADD_BACKGROUND_FAILURE,
  ADD_BACKGROUND_SUCCESS,
  DELETE_BACKGROUND,
  DELETE_BACKGROUND_FAILURE,
  DELETE_BACKGROUND_SUCCESS,
  DELETE_INTERVIEWS,
  DELETE_INTERVIEWS_FAILURE,
  DELETE_INTERVIEWS_SUCCESS,
  GET_BACKGROUND_LISTING,
  GET_BACKGROUND_LISTING_FAILURE,
  GET_BACKGROUND_LISTING_SUCCESS,
  GET_INTERVIEWS_LISTING,
  GET_INTERVIEWS_LISTING_FAILURE,
  GET_INTERVIEWS_LISTING_SUCCESS,
  TOGGLE_INTERVIEW_TAB,
} from "../constants";

export default class InterviewsAction {
  static toggleTab(payload) {
    return {
      type: TOGGLE_INTERVIEW_TAB,
      payload,
    };
  }
  static getInterviewsListing(payload, cb) {
    return {
      type: GET_INTERVIEWS_LISTING,
      payload,
      cb,
    };
  }
  static getInterviewsListingSuccess(payload) {
    return {
      type: GET_INTERVIEWS_LISTING_SUCCESS,
      payload,
    };
  }
  static getInterviewsListingFailure() {
    return {
      type: GET_INTERVIEWS_LISTING_FAILURE,
    };
  }
  static deleteInterviews(id, cb) {
    return {
      type: DELETE_INTERVIEWS,
      id,
      cb,
    };
  }
  static deleteInterviewsSuccess(payload) {
    return {
      type: DELETE_INTERVIEWS_SUCCESS,
      payload,
    };
  }
  static deleteInterviewsFailure() {
    return {
      type: DELETE_INTERVIEWS_FAILURE,
    };
  }

  static getBackgroundListing(payload, cb) {
    return {
      type: GET_BACKGROUND_LISTING,
      payload,
      cb,
    };
  }

  static getBackgroundListingSuccess(payload) {
    return {
      type: GET_BACKGROUND_LISTING_SUCCESS,
      payload,
    };
  }

  static getBackgroundListingFailure(payload) {
    return {
      type: GET_BACKGROUND_LISTING_FAILURE,
      payload,
    };
  }

  static addBackground(payload, cb) {
    return {
      type: ADD_BACKGROUND,
      payload,
      cb,
    };
  }

  static addBackgroundSuccess(payload) {
    return {
      type: ADD_BACKGROUND_SUCCESS,
      payload,
    };
  }

  static addBackgroundFailure(payload) {
    return {
      type: ADD_BACKGROUND_FAILURE,
      payload,
    };
  }

  static deleteBackground(id, cb) {
    return {
      type: DELETE_BACKGROUND,
      id,
      cb,
    };
  }

  static deleteBackgroundSuccess(payload) {
    return {
      type: DELETE_BACKGROUND_SUCCESS,
      payload,
    };
  }

  static deleteBackgroundFailure(payload) {
    return {
      type: DELETE_BACKGROUND_FAILURE,
      payload,
    };
  }
}
